/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Noactivitydescription2Inputs */

const id_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembukaan pencapaian akan muncul di sini ketika profil ini memiliki kemajuan publik.`)
};

const ms_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukaan pencapaian akan muncul di sini apabila profil ini mempunyai kemajuan awam.`)
};

const da_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement-oplåsninger vil vises her når denne profil har offentlig fremgang.`)
};

const de_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften-Freischaltungen erscheinen hier, wenn dieses Profil öffentlichen Fortschritt hat.`)
};

const en_us2_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement unlocks will appear here when this profile has public progress.`)
};

const es_es2_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los desbloqueos de logros aparecerán aquí cuando este perfil tenga progreso público.`)
};

const es_mx2_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los desbloqueos de logros aparecerán aquí cuando este perfil tenga progreso público.`)
};

const fil_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lilitaw dito ang mga unlock ng achievement kapag ang profile na ito ay may pampublikong progress.`)
};

const fr_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les déblocages de succès apparaîtront ici lorsque ce profil aura une progression publique.`)
};

const it_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli sblocchi dei risultati appariranno qui quando questo profilo avrà progressi pubblici.`)
};

const hu_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljesítményfeloldások itt jelennek meg, ha ez a profil nyilvános előrehaladással rendelkezik.`)
};

const nl_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatie-ontgrendelingen verschijnen hier wanneer dit profiel openbare voortgang heeft.`)
};

const no_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjonsopplåsinger vil vises her når denne profilen har offentlig fremgang.`)
};

const pl_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odblokowania osiągnięć pojawią się tutaj, gdy ten profil będzie miał publiczny postęp.`)
};

const pt_br2_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os desbloqueios de conquistas aparecerão aqui quando este perfil tiver progresso público.`)
};

const pt_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os desbloqueios de conquistas aparecerão aqui quando este perfil tiver progresso público.`)
};

const ro_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblocările de realizări vor apărea aici când acest profil va avea progres public.`)
};

const fi_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutusten avaukset näkyvät täällä, kun tällä profiililla on julkinen edistyminen.`)
};

const sv_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationsupplåsningar kommer att visas här när denna profil har offentlig framgång.`)
};

const vi_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các thành tích đã mở khóa sẽ xuất hiện ở đây khi hồ sơ này có tiến trình công khai.`)
};

const tr_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu profilde halka açık ilerleme olduğunda başarım açılımları burada görünecektir.`)
};

const cs_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odemčení úspěchů se zde zobrazí, jakmile bude mít tento profil veřejný postup.`)
};

const bg_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключванията на постижения ще се покажат тук, когато този профил има публичен напредък.`)
};

const ru_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытые достижения появятся здесь, когда у этого профиля будет публичный прогресс.`)
};

const uk_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розблокування досягнень з'являться тут, коли цей профіль матиме публічний прогрес.`)
};

const ar_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستظهر عمليات فتح الإنجازات هنا عندما يكون لهذا الملف الشخصي تقدم عام.`)
};

const hi_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब इस प्रोफ़ाइल की सार्वजनिक प्रगति होगी, तब यहाँ उपलब्धि अनलॉक दिखाई देंगे।`)
};

const th_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปลดล็อกความสำเร็จจะปรากฏที่นี่เมื่อโปรไฟล์นี้มีความคืบหน้าสาธารณะ`)
};

const ja_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロフィールが公開進行状況を持っている場合、ここに実績解除が表示されます。`)
};

const zh_cn2_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就解锁动态将在该档案拥有公开进度后出现在这里。`)
};

const zh_hant1_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就解鎖動態將在該檔案擁有公開進度後出現在這裡。`)
};

const ko_profile_activity_noactivitydescription2 = /** @type {(inputs: Profile_Activity_Noactivitydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 프로필에 공개 진행 상황이 있으면 도전 과제 잠금 해제가 여기에 표시됩니다.`)
};

/**
* | output |
* | --- |
* | "Achievement unlocks will appear here when this profile has public progress." |
*
* @param {Profile_Activity_Noactivitydescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_noactivitydescription2 = /** @type {((inputs?: Profile_Activity_Noactivitydescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Noactivitydescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_noactivitydescription2(inputs)
	if (locale === "ms") return ms_profile_activity_noactivitydescription2(inputs)
	if (locale === "da") return da_profile_activity_noactivitydescription2(inputs)
	if (locale === "de") return de_profile_activity_noactivitydescription2(inputs)
	if (locale === "en-US") return en_us2_profile_activity_noactivitydescription2(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_noactivitydescription2(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_noactivitydescription2(inputs)
	if (locale === "fil") return fil_profile_activity_noactivitydescription2(inputs)
	if (locale === "fr") return fr_profile_activity_noactivitydescription2(inputs)
	if (locale === "it") return it_profile_activity_noactivitydescription2(inputs)
	if (locale === "hu") return hu_profile_activity_noactivitydescription2(inputs)
	if (locale === "nl") return nl_profile_activity_noactivitydescription2(inputs)
	if (locale === "no") return no_profile_activity_noactivitydescription2(inputs)
	if (locale === "pl") return pl_profile_activity_noactivitydescription2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_noactivitydescription2(inputs)
	if (locale === "pt") return pt_profile_activity_noactivitydescription2(inputs)
	if (locale === "ro") return ro_profile_activity_noactivitydescription2(inputs)
	if (locale === "fi") return fi_profile_activity_noactivitydescription2(inputs)
	if (locale === "sv") return sv_profile_activity_noactivitydescription2(inputs)
	if (locale === "vi") return vi_profile_activity_noactivitydescription2(inputs)
	if (locale === "tr") return tr_profile_activity_noactivitydescription2(inputs)
	if (locale === "cs") return cs_profile_activity_noactivitydescription2(inputs)
	if (locale === "bg") return bg_profile_activity_noactivitydescription2(inputs)
	if (locale === "ru") return ru_profile_activity_noactivitydescription2(inputs)
	if (locale === "uk") return uk_profile_activity_noactivitydescription2(inputs)
	if (locale === "ar") return ar_profile_activity_noactivitydescription2(inputs)
	if (locale === "hi") return hi_profile_activity_noactivitydescription2(inputs)
	if (locale === "th") return th_profile_activity_noactivitydescription2(inputs)
	if (locale === "ja") return ja_profile_activity_noactivitydescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_noactivitydescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_noactivitydescription2(inputs)
	return ko_profile_activity_noactivitydescription2(inputs)
});
export { profile_activity_noactivitydescription2 as "profile.activity.noActivityDescription" }